import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

  readonly year = new Date().getFullYear();

  // Mismas secciones y anclas que el menú superior (header-top)
  readonly navItems = [
    { name: 'Inicio', id: '' },
    { name: 'Servicios', id: 'proyectos' },
    { name: 'Quiénes somos', id: 'equipo' },
    { name: 'Testimonios', id: 'cursos' },
    { name: 'FAQ', id: 'preguntas-frecuentes' },
    { name: 'Contáctanos', id: 'contacto' }
  ];

  // Mismos perfiles que la tarjeta de "Sobre mí" y la sección de contacto
  readonly socialLinks = [
    { label: 'Instagram', icon: 'fab fa-instagram', url: 'https://www.instagram.com/psicologa.nataliaguecha/' },
    { label: 'LinkedIn', icon: 'fab fa-linkedin-in', url: 'https://www.linkedin.com/in/natalia-güechá-nieto-91a636244/' },
    { label: 'TikTok', icon: 'fab fa-tiktok', url: 'https://www.tiktok.com/@psicologa.nataliaguecha' },
    { label: 'WhatsApp', icon: 'fab fa-whatsapp', url: 'https://wa.me/573104671284' }
  ];

  constructor(private router: Router) {}

  // En la portada se desplaza con el mismo margen del menú fijo; desde otra
  // ruta (ficha de producto, resultado de pago) vuelve a la portada y al ancla.
  goToSection(id: string, event: Event): void {
    event.preventDefault();

    if (!id) {
      if (this.router.url.split('#')[0] === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        this.router.navigate(['/']);
      }
      return;
    }

    const element = document.getElementById(id);
    if (element) {
      const top = element.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top, behavior: 'smooth' });
    } else {
      this.router.navigate(['/'], { fragment: id });
    }
  }
}
